import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const StorageConditionList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="storageCondition"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default StorageConditionList;
